import { createElement, lazy } from 'react'

import { routes } from '../routes'
import { registerRoute } from '../utils/routeRegistry'

const DealerSelector = lazy(() => import('./components/dealerSelector'))

const initRoute = () => {
    registerRoute({ path: routes.DEALER_SELECTOR, element: createElement(DealerSelector) })
}

export default initRoute
